import React, { useCallback } from "react";
import { connect } from "react-redux";

import { Company, EntityType, Person } from "@mapmycustomers/shared/types/entity";
import { OutOfCadenceEntity } from "@mapmycustomers/shared/types/entity/activities/OutOfCadenceEntity";

import useRecordsOverCadenceColumns from "@app/component/ListModalForCharts/useRecordsOverCadenceColumns";
import useSourceListModalColumns from "@app/component/ListModalForCharts/useSourceListModalColumns";
import PreviewListModal from "@app/component/PreviewListModal";
import ChartType from "@app/scene/home/enum/ChartType";
import { showEntityView } from "@app/store/entityView/actions";

export interface Props {
  chartType: ChartType.ENGAGEMENT | ChartType.SOURCE;
  onHide: () => void;
  onPageChange?: (page: number) => void;
  page?: number;
  pageSize?: number;
  records: OutOfCadenceEntity[];
  showEntityView: typeof showEntityView;
  title?: React.ReactNode;
  totalRecords?: number;
}

const ListModalForCharts: React.FC<Props> = ({
  chartType,
  onHide,
  onPageChange,
  page,
  pageSize,
  records,
  showEntityView,
  title,
  totalRecords,
}) => {
  const handleCompanyClick = useCallback(
    (entityId: Company["id"]) => showEntityView({ entityId, entityType: EntityType.COMPANY }),
    [showEntityView]
  );

  const handlePersonClick = useCallback(
    (entityId: Person["id"]) => showEntityView({ entityId, entityType: EntityType.PERSON }),
    [showEntityView]
  );

  const recordsOverCadenceColumns = useRecordsOverCadenceColumns(
    handleCompanyClick,
    handlePersonClick
  );
  const sourceByTypeColumns = useSourceListModalColumns(handleCompanyClick, handlePersonClick);
  const columns = chartType === "engagement" ? recordsOverCadenceColumns : sourceByTypeColumns;

  return (
    <PreviewListModal
      columns={columns}
      onHide={onHide}
      onPageChange={onPageChange}
      page={page}
      pageSize={pageSize}
      records={records}
      title={title}
      totalRecords={totalRecords}
    />
  );
};

const mapDispatchToProps = {
  showEntityView,
};

export default connect(null, mapDispatchToProps)(ListModalForCharts);
